module.exports = __webpack_public_path__ + "img/HidroSensorPoco3D.3206e031.png";